import React, { FunctionComponent, ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './BaseDialogButton.module.css';

export type BaseDialogButtonProps = ComponentProps<'button'>;

export const BaseDialogButton: FunctionComponent<BaseDialogButtonProps> =
  React.memo((props) => {
    const { children, className, ...remainingProps } = prepareProps({ props });

    return (
      <button
        type="button"
        {...remainingProps}
        className={classes(className, styles.button)}
      >
        {children}
      </button>
    );
  });
